export default __webpack_public_path__ + "static/media/swingJumpThumb.8f2593c5.png";